module.exports = __webpack_public_path__ + "img/view-eye.85fd085c.svg";